import { ReduxSagaRequest } from "@hlibs/index";
import * as Requests from "./requests";

class Advertisement extends ReduxSagaRequest {
  static create = (name, funcAsync = null, funcResult = null) =>
    new Advertisement(name, funcAsync, funcResult);
  get ad() {
    return super.getState("ad");
  }
  // callback : (data, response) => {}
  excel(from, to, callback = null) {
    super.request({ type: "Excel", params: { from, to }, callback });
  }
  stats(from, to, callback = null){
    super.request({ type: "Stats", params: {from, to}, callback});
  }
  info(ad_id, callback = null) {
    super.request({ type: "Info", params: { ad_id }, callback });
  }
  list(callback = null) {
    super.request({ type: "List", callback });
  }
  add(datas, callback = null) {
    super.request({ type: "Add", params: datas, callback });
  }
  update(datas, callback = null) {
    super.request({ type: "Update", params: datas, callback });
  }
  update2(datas, callback = null) {
    super.request({ type: "Update2", params: datas, callback });
  }
  delete(ad_id, callback = null) {
    super.request({ type: "Delete", params: { ad_id }, callback });
  }

  cleanLoginResponse() {
    super.set(null, "excel");
  }
}

const reduxModule = Advertisement.create("Advertisement", async (payload) => {
  switch (payload.type) {
    case "Excel":
      return await Requests.Excel(
        payload.params,
        payload.callback,
        reduxModule
      );
    case "Stats":
      return await Requests.Stats(
        payload.params, 
        payload.callback, 
        reduxModule
      );
    case "List":
      return await Requests.List(payload.callback, reduxModule);
    case "Info":
      return await Requests.Info(payload.params, payload.callback, reduxModule);
    case "Add":
      return await Requests.Add(payload.params, payload.callback, reduxModule);
    case "Update":
      return await Requests.Update(
        payload.params,
        payload.callback,
        reduxModule
      );
    case "Update2":
      return await Requests.Update2(
        payload.params,
        payload.callback,
        reduxModule
      );
    case "Delete":
      return await Requests.Delete(
        payload.params,
        payload.callback,
        reduxModule
      );
    default:
      const errorMessage = "Error: Redux (Advertisement) has wrong type : " + payload.type;
      throw errorMessage;
  }
});

export default reduxModule;
